import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { APP_URL, EASE } from "@/lib/site";

const MotionLink = motion.a;

export const BuddyToast = () => (
  <motion.div
    data-testid="hero-buddy-toast"
    initial={{ opacity: 0, scale: 0.7, x: -30 }}
    animate={{ opacity: 1, scale: 1, x: 0 }}
    transition={{ duration: 0.8, delay: 1.9, ease: EASE }}
    className="absolute left-[56%] top-[30%] z-20 w-[205px] sm:left-[78%] sm:w-[250px]"
    style={{ transform: "translateZ(60px)" }}
  >
    <motion.div
      animate={{ y: [0, -8, 0] }}
      transition={{ duration: 4, repeat: Infinity, ease: "easeInOut", delay: 2.7 }}
      className="rounded-2xl border border-[#f5c451]/60 bg-[#16181f]/90 p-3.5 shadow-[0_24px_60px_-20px_rgba(0,0,0,0.9),0_0_40px_-12px_rgba(245,196,81,0.5)] backdrop-blur-xl"
    >
      <div className="flex items-center gap-3">
        <span className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#a78bfa] text-sm font-bold text-[#1a1033]">
          J
          <span className="pulse-dot absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full border-2 border-[#16181f] bg-[#4ade80]" />
        </span>
        <div className="min-w-0">
          <p className="text-sm font-semibold leading-tight text-[#f2f3f5]">Jess is doing Glutes today</p>
          <p className="mt-0.5 text-xs leading-snug text-[#b3b8c1]">Tap to do the same and train together</p>
        </div>
      </div>
      <MotionLink
        href={APP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="hero-buddy-toast-cta"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.9, delay: 2.5, ease: EASE }}
        whileHover={{ scale: 1.04 }}
        whileTap={{ scale: 0.96 }}
        className="group mt-3 flex origin-left items-center justify-center gap-1.5 rounded-full bg-grad py-2 text-xs font-semibold text-[#1a0b05] shadow-[0_8px_24px_-8px_rgba(255,106,61,0.8)]"
      >
        Train together
        <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </MotionLink>
    </motion.div>
  </motion.div>
);
